// The starting weight for the two Face rig controls (`rigconstrain`, `livemouth`).
//
// ONE constant for both, in one place, because they are the same decision: each
// asks "how much of this does this character want?" and each was previously
// pinned at an end of its range that does not suit a narrow capture.
//
//   rigconstrain  was 1 -- fully constrained. At 1 a narrow capture cannot
//                 speak: the trained-domain clamp alone keeps only ~40% of the
//                 median ARKit channel's travel on a 30-pose bundle. At 0 the
//                 idle animation blows the face out.
//   livemouth     was 0.65. All of the mix overrides A2F's own expression; none
//                 of it leaves the mouth off the trained manifold.
//
// Both now start in the middle, so an untuned character sits between the two
// failure modes rather than at one of them, and the sliders move outward from
// there in either direction.
//
// NOT liveRigRegions' DEFAULT_LIVE_MOUTH_WEIGHT (0.65). That constant keeps its
// own meaning -- the weight the mouth mix SHIPPED with -- and call sites that
// describe the shipped face still refer to it. What changed is where a
// character starts.
export const DEFAULT_FACE_RIG_WEIGHT = 0.5
